<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
.bg-zebra {
  background-color: #32A5AB !important;
}
.btn-zebra {
  background-color: #32A5AB !important;
  color: white !important;
}

.color-zebra {
  background-color: #32A5AB !important;
  color: white !important;
}

.accordion-button[data-v-230caef8]:not(.collapsed) {
  background-color: #32A5AB !important;
  color: white !important
}

.text-zebra {
  color: #32A5AB !important;
}
.bg-zebra-light {
    background-color: rgb(0 178 169 / 0.1) !important;
}

/* .accordion-item:first-of-type>.accordion-header .accordion-button {
  background-color: #32A5AB !important;
  color: white !important
} */

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.table thead tr th {
  border-bottom: 1px solid #113f43;
  border-top: none;
  background-color: #00727C;
  color: #fff;
  font-weight: 400;
  min-width: 150px;
}


</style>
